import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SendbirdUserMessage } from '../Types';
import { currentMessagesSelector } from '../shared/redux/selectors';

interface EventData {
  groupEvent: {
    id: string; // Assuming the eventId is a string
  };
}

const useGetMessagesForEventId = (
  targetEventId: string
): SendbirdUserMessage[] => {
  // Get chat messages from the Redux state
  const chatMessages = useSelector(
    currentMessagesSelector
  ) as SendbirdUserMessage[];

  // Return the filtered messages using useMemo to optimize recalculation
  return useMemo(() => {
    return chatMessages?.filter((message) => {
      if (message.customType === 'groupevent') {
        const eventData: EventData = JSON.parse(message.data); // Parse the event data

        return eventData.groupEvent.id === targetEventId; // Check if the event ID matches
      }

      return false;
    });
  }, [chatMessages, targetEventId]); // Recompute when chatMessages or targetEventId change
};

export default useGetMessagesForEventId;
